module.exports = __webpack_public_path__ + "/images/82c03a315597db2694815593d30d6d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/theater-top.png
// module id = 796
// module chunks = 0